<template>
    <div class="container mx-auto px-4 py-8">
        <section class="bg-white rounded-md shadow border-t-4 border-nerve p-6 sm:p-10">
            <div class="flex flex-col sm:flex-row gap-6 sm:gap-8">
                <div class="flex items-center justify-center shrink-0 w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-nerve-50 border border-nerve-200 text-nerve">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" class="w-10 h-10 sm:w-12 sm:h-12" aria-hidden="true">
                        <circle cx="12" cy="12" r="9" />
                        <path d="M5.6 5.6l12.8 12.8" />
                    </svg>
                </div>

                <div class="flex-1 min-w-0">
                    <span class="block text-sm font-bold uppercase tracking-wide text-nerve mb-1">
                        Platform suspended
                    </span>
                    <h1 class="m-0 mb-4">
                        This user platform has been suspended
                    </h1>
                    <p class="text-dust-700 max-w-2xl mb-6">
                        Challenges, ideas and forums hosted on this platform are unavailable
                        because it doesn't meet BigNerve's community guidelines. You can keep
                        exploring open challenges across the rest of BigNerve.
                    </p>

                    <div class="flex flex-wrap gap-3">
                        <router-link :to="{ name: 'home' }" class="btn px-6 py-2">
                            Explore BigNerve challenges
                        </router-link>
                        <router-link :to="{ name: 'code-of-conduct' }" class="btn is-white px-6 py-2">
                            Read community guidelines
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
